import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const mergeSxProps = (
  ...sxProps: (SxProps<Theme> | undefined)[]
): SxProps<Theme> => Object.assign({}, ...sxProps);
